<template>
  <coozzy-card
    class="global-card mb-3"
    :title="$t('message.marketingSettings.automaticReferenceCheck.title')">
    <b-card-sub-title>
      {{ $t('message.marketingSettings.automaticReferenceCheck.subTitle') }}
    </b-card-sub-title>
    <div class="row mt-3">
      <div class="col-sm-6 col-md-4 mb-2">
        <label>{{ $t('message.marketingSettings.automaticReferenceCheck.query') }}</label>
        <coozzy-form-select
          v-model="localQueryMode"
          data-cy="marketing-edit-advert-automatic-reference-check-select">
          <option :value="queryModes.NONE">
            {{ $t('message.marketingSettings.automaticReferenceCheck.queryNone') }}
          </option>
          <option :value="queryModes.AFFORDABILITY">
            {{ $t('message.marketingSettings.automaticReferenceCheck.queryAffordability') }}
          </option>
          <option :value="queryModes.COMPLETE_DOSSIER_AND_AFFORDABILITY">
            {{ $t('message.marketingSettings.automaticReferenceCheck.queryCompleteDossier') }}
          </option>
        </coozzy-form-select>
      </div>
    </div>
    <div
      v-if="showSenderMailbox"
      class="row mt-2">
      <div class="col-sm-6 col-md-4 mb-2">
        <label>{{ $t('message.marketingSettings.automaticReferenceCheck.senderEmail') }}*</label>
        <div
          v-if="loadingMailboxes"
          class="text-center py-2">
          <coozzy-spinner />
        </div>
        <coozzy-form-select
          v-else
          v-model="localSenderMailboxId"
          data-cy="marketing-edit-advert-automatic-reference-check-sender-select"
          :state="showSenderValidationError ? false : null">
          <option value="">
            -
          </option>
          <option
            v-for="mailbox in mailBoxList"
            :key="mailbox.id"
            :value="mailbox.id">
            {{ mailbox.outboundEmail }}
          </option>
        </coozzy-form-select>
      </div>
    </div>
  </coozzy-card>
</template>

<script>
import CoozzyCard from '@/framework/components/card/CoozzyCard'
import CoozzyFormSelect from '@/framework/components/form/select/CoozzyFormSelect.vue'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner'
import MessageApi from '@/misc/apis/MessageApi'
import { user } from '@/mixins/user'
import Vue from 'vue'
import { REFERENCE_CHECK_QUERY_MODES } from '@/types/models'

export default {
  name: 'AutomaticReferenceCheckCard',
  components: {
    CoozzySpinner,
    CoozzyFormSelect,
    CoozzyCard
  },
  mixins: [user],
  model: {
    prop: 'queryMode',
    event: 'input'
  },
  props: {
    queryMode: {
      type: String,
      required: true
    },
    senderMailboxId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loadingMailboxes: false,
      mailBoxList: [],
      queryModes: REFERENCE_CHECK_QUERY_MODES,
      validationAttempted: false
    }
  },
  computed: {
    localQueryMode: {
      get() {
        return this.queryMode
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    localSenderMailboxId: {
      get() {
        const id = this.senderMailboxId
        if (!id) {
          return ''
        }
        const inList = this.mailBoxList.some(mailbox => String(mailbox.id) === String(id))
        return inList ? id : ''
      },
      set(value) {
        this.$emit('update:senderMailboxId', value)
      }
    },
    showSenderMailbox() {
      return this.queryMode !== REFERENCE_CHECK_QUERY_MODES.NONE
    },
    showSenderValidationError() {
      return this.validationAttempted && this.showSenderMailbox && !this.senderMailboxId
    }
  },
  watch: {
    showSenderMailbox(visible) {
      if (visible && !this.mailBoxList.length && !this.loadingMailboxes) {
        this.loadMailboxes()
      }
    }
  },
  mounted() {
    this.loadMailboxes()
  },
  methods: {
    loadMailboxes() {
      this.loadingMailboxes = true
      const request = this.isCompanyAdmin
        ? MessageApi.listMailboxes(this.accountId)
        : MessageApi.listMailboxesByUserId(this.$store.getters['user/getUserId'])
      return request
        .then(response => {
          this.mailBoxList = (response.mailboxes || []).filter(mailbox => mailbox.active)
        })
        .catch(() => {
          Vue.toasted.show(this.$t('message.loadingErrors.mailbox'), { type: 'error' })
        })
        .finally(() => {
          this.loadingMailboxes = false
        })
    },
    isInvalid() {
      this.validationAttempted = true
      if (!this.showSenderMailbox) {
        return false
      }
      if (this.senderMailboxId) {
        return false
      }
      return true
    }
  }
}
</script>
